module.exports = __webpack_public_path__ + "static/media/errorIcon.fa192f62.svg";